// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3PAI9","m-signature-pad--body":"styles__m-signature-pad--body___2SMTZ","m-signature-pad--footer":"styles__m-signature-pad--footer___lSN4S","description":"styles__description___H9kFJ","button":"styles__button___o5xmv","clear":"styles__clear___WRDnX","save":"styles__save___1tYGv","m-signature-pad":"styles__m-signature-pad___2VqAp","github":"styles__github___3wKYG","due":"styles__due___5H12u","overdue":"styles__overdue____0oQh"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/DueDate/styles.scss
// module id = lIXC
// module chunks = client